import { render } from "./FileManagerLightbox.vue?vue&type=template&id=0dd8340c"
import script from "./FileManagerLightbox.vue?vue&type=script&lang=js"
export * from "./FileManagerLightbox.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/service/service-cp-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__